import React, { useEffect, useMemo, useState } from "react";
import Chart from "react-google-charts";
import { useDispatch, useSelector } from "react-redux";
import SelectOption from "../../../components/atoms/formFields/selectOption";
import { dashPastTrendsThunk } from "../../../store/thunks/dashboardThunk";
import AllToolTip from "../../../components/atoms/Tooltip/AllToolTips";

const PastTrends = () => {
  const dispatch = useDispatch();

  const { data } = useSelector((state) => state?.dashPastTrends || {});
  const { months = [], products = [] } = data || {};

  const [selectOptions, setSelectOptions] = useState([]);

  useEffect(() => {
    if (products.length && !selectOptions.length) {
      setSelectOptions(
        products.map((p) => ({
          label: p.name,
          value: p.sku,
        }))
      );
    }
  }, [products, selectOptions.length]);

  const chartData = useMemo(() => {
    if (!months.length || !products.length) {
      return [["Month"]];
    }
    return [
      ["Month", ...products.map((p) => p.name)],
      ...months.map((month) => [
        month,
        ...products.map((p) => p.monthlySales?.[month] || 0),
      ]),
    ];
  }, [months, products]);

  const [filter, setFilter] = useState({
    productIds: [],
  });

  useEffect(() => {
    dispatch(
      dashPastTrendsThunk({
        topSellingProduct: {
          productIds: filter.productIds,
        },
      })
    );
  }, [dispatch, filter]);

  return (
    <div className="card card-custom h-100">
      <div className="bg-gray-700 border-1 border-bottom card-header min-h-auto py-3">
           <h4
          className="card-label font-weight-bold text-white"
          style={{ margin: " 7px 0" }}
        >
          Units Ordered (Last 4 Months)
          <AllToolTip text="Displays total quantity of items ordered over the last 4 months." />
        </h4>
      </div>

      <div className="card-body p-4">
        <SelectOption
          name={""}
          placeholder="Select Product Name"
          isClearable
          checkboxes={true}
          isMulti={true}
          options={selectOptions}
          value={selectOptions.filter((option) =>
            filter.productIds.includes(option.value)
          )}
          onChange={(selectedOptions) => {
            setFilter({
              ...filter,
              productIds: selectedOptions
                ? selectedOptions.map((item) => item.value)
                : [],
            });
          }}
        />

        {chartData?.length <= 1 ? (
          <p className="text-center mt-5">No data available</p>
        ) : (
          <Chart
            chartType="ColumnChart"
            width="100%"
            height="450px"
            data={chartData}
            options={{
              colors: ['#1b9e77', '#d95f02','#66a61e', '#e6ab02', '#a6761d', '#666666'],
              legend: { position: "right" },
              bar: { groupWidth: "70%" },
              hAxis: { title: "Months" },
              vAxis: { title: "Units Ordered" },
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PastTrends;
